import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["mode", "size", "theme", "disabled", "children", "onChange", "value", "defaultValue", "error", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@rescui/menu';
import cn from 'classnames';
import styles from './checkbox.p.module.css.js';
import CheckboxManager from './checkbox-manager.js';

var CheckboxList = function CheckboxList(_ref) {
  var mode = _ref.mode,
      size = _ref.size,
      theme = _ref.theme,
      disabled = _ref.disabled,
      children = _ref.children,
      onChange = _ref.onChange,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      error = _ref.error,
      className = _ref.className,
      style = _ref.style,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CheckboxManager, {
    theme: theme,
    defaultValue: defaultValue,
    isError: false,

    /* error={Boolean(error)}  Don't show error on every checkbox */
    onChange: onChange,
    value: value,
    disabled: disabled,
    size: size,
    mode: mode
  }, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, error && typeof error !== 'boolean' && /*#__PURE__*/React.createElement("div", {
    className: cn(styles.errorMessage, styles.list)
  }, error), /*#__PURE__*/React.createElement(Menu, _objectSpread({
    tag: 'div',
    itemTag: null,
    size: size,
    mode: 'clear',
    disabled: disabled,
    theme: theme
  }, restProps), children)));
};

CheckboxList.propTypes = {
  mode: PropTypes.oneOf(['classic', 'rock']),
  size: PropTypes.oneOf(['s', 'm', 'l']),
  onChange: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.array,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool
};
export { CheckboxList as default };
